import React, { useState } from 'react';
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { IoBuildOutline, IoGameController } from 'react-icons/io5';
import { DiAtom } from 'react-icons/di';


const items: MenuProps['items'] = [
	{
		label: <Link to={'/'}></Link>,
		key: 'kaptis',
		icon: <img src={require("images/kaptis-logo-border.png")} height={50} style={{marginTop: "10px"}}/>,
	},
	{
		label: <Link to={'games'}>Games</Link>,
		key: 'games',
		icon: <IoGameController />,
	},
	{
		label: <Link to={'about'}>About Us</Link>,
		key: 'about',
	},
];

export const MenuBar: React.FC = () => {
	const [current, setCurrent] = useState('mail');

	const onClick: MenuProps['onClick'] = (e) => {
		console.log('click ', e);
		setCurrent(e.key);
	};

	return (
			<Menu theme='dark' style={menuStyle} onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} />
	);
};

const menuStyle:React.CSSProperties = {
	position: 'fixed', top:0, right:0, left: 0, zIndex: 100,
	borderRadius: 1, maxHeight: 100, alignItems: "center"
}